export default {"src":"/_next/static/media/bg_yellow_m.5dca5ed8.svg","height":725,"width":639,"blurWidth":0,"blurHeight":0};